module.exports = __webpack_public_path__ + "media/typing.9672a7de.mp3";